import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import { t } from '@/i18n';
import { axios } from '@/lib/utils/axios';
import type { Organization } from '../../common/organization';
import { getResponse, toastApiError } from '../common';
import { API_URLS, queryClient } from '../query.client';

export type UpdateOrganizationSuccessResponseType = { message: string };

async function updateOrganization(
	id: string,
	payload: Omit<Organization, 'id'>,
): Promise<UpdateOrganizationSuccessResponseType | null> {
	const response = await axios.put(`${API_URLS.ORGANIZATIONS.INDEX}/${id}`, payload);
	return getResponse<UpdateOrganizationSuccessResponseType>(response.data);
}
export type UpdateOrganizationPayloadType = {
	id: string;
	payload: Omit<Organization, 'id'>;
};
export function updateOrganizationOptions() {
	return mutationOptions({
		mutationFn: ({ id, payload }: UpdateOrganizationPayloadType) => updateOrganization(id, payload),
		onSuccess: async (data) => {
			console.log('Organization updated successfully:', data);
			toast.success(t('admin.toast.organizationUpdated'));
			await queryClient.invalidateQueries({ queryKey: ['organizations'] });
		},
		onError: (error) => toastApiError(error),
	});
}
